// Constants
import { concatStyleSets } from "@fluentui/react";
// Styles
import { backgroundColorNeutralSecondary, flexChildSizeFlexible, flexParent, ghostTextStyle } from "../../../utilities/Mixin.styles";
// Utilities
import { memoizeFunction } from "@fluentui/react";
import { Colors } from "@ms/uno-constants/lib/local/Colors";
/**
 * Task Assignment Control style override to use within Task Editor Wrapper
 */ export const TaskEditorWrapperAssignmentStyles = memoizeFunction((theme, isReadonly)=>{
    return {
        root: [
            flexChildSizeFlexible(),
            flexParent(),
            {
                width: "100%"
            }
        ],
        assigneeRow: [
            {
                ".assignLabel": [
                    ghostTextStyle(theme),
                    {
                        padding: "0px 5px"
                    }
                ],
                "> .ms-Facepile": {
                    margin: "7px 0px"
                },
                "> .ms-Facepile-addButton i": {
                    margin: "2px 5px 0px -2px",
                    ...isReadonly && {
                        color: Colors.NeutralTertiary
                    }
                }
            },
            !isReadonly && {
                ":hover .addFriendIcon": backgroundColorNeutralSecondary(theme)
            }
        ],
        addFriendIcon: [
            flexParent(),
            {
                justifyContent: "center",
                alignItems: "center",
                width: "32px",
                minWidth: "32px",
                height: "32px",
                marginRight: "2px",
                marginLeft: "0px"
            }
        ],
        assignDiv: {
            marginLeft: "-8px"
        }
    };
});
/**
 * Task Editor Container styles for the loading spinner, used in the modal when the task editor is loading
 * @param theme - Fluent UI theme object
 * @param modalSuspenseStyle - Additional styles to apply to the loading spinner
 */ export const getLoadingSpinnerStyles = memoizeFunction((theme, modalSuspenseStyle)=>{
    const emptyModal = {
        position: "fixed",
        top: "50%",
        left: "50%",
        display: "flex",
        transform: "translate(-50%, -50%)",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        backgroundColor: theme.semanticColors.bodyBackground,
        boxShadow: "rgba(0, 0, 0, 0.4) 0px 0px 5px 0px"
    };
    return concatStyleSets(modalSuspenseStyle, emptyModal);
});
